"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PortalImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing Portal operations. */
var PortalImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class Portal class.
   * @param client Reference to the service client
   */
  function PortalImpl(client) {
    (0, _classCallCheck2["default"])(this, PortalImpl);
    this.client = client;
  }
  /**
   *  (Auth: RhinestoneAuthorize[portalId])
   * @param portalId (Access Controlled)
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(PortalImpl, [{
    key: "getPortal",
    value: function getPortal(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getPortalOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId])
     * @param portalId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getPortalProperties",
    value: function getPortalProperties(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getPortalPropertiesOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId])
     * @param portalId (Access Controlled)
     * @param propertyName
     * @param options The options parameters.
     */

  }, {
    key: "getPortalProperty",
    value: function getPortalProperty(portalId, propertyName, options) {
      var operationArguments = {
        portalId: portalId,
        propertyName: propertyName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getPortalPropertyOperationSpec);
    }
  }]);
  return PortalImpl;
}(); // Operation Specifications


exports.PortalImpl = PortalImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getPortalOperationSpec = {
  path: "/api/portals/{portalId}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.PortalConfigurationDto
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getPortalPropertiesOperationSpec = {
  path: "/api/portals/{portalId}/properties",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PortalPropertyDto"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getPortalPropertyOperationSpec = {
  path: "/api/portals/{portalId}/properties/{propertyName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.PortalPropertyDto
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.propertyName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};